/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Where a not-yet-ended schedule is in its lifecycle. ACTIVE matches the schedule served to players.
 * @export
 */
export const RewardScheduleStatus = {
    ACTIVE: 'ACTIVE',
    UPCOMING: 'UPCOMING',
    NOT_READY: 'NOT_READY',
    unknown_default_open_api: '11184809'
} as const;
export type RewardScheduleStatus = typeof RewardScheduleStatus[keyof typeof RewardScheduleStatus];


export function instanceOfRewardScheduleStatus(value: any): boolean {
    for (const key in RewardScheduleStatus) {
        if (Object.prototype.hasOwnProperty.call(RewardScheduleStatus, key)) {
            if (RewardScheduleStatus[key as keyof typeof RewardScheduleStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RewardScheduleStatusFromJSON(json: any): RewardScheduleStatus {
    return RewardScheduleStatusFromJSONTyped(json, false);
}

export function RewardScheduleStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): RewardScheduleStatus {
    return json as RewardScheduleStatus;
}

export function RewardScheduleStatusToJSON(value?: RewardScheduleStatus | null): any {
    return value as any;
}

